import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  SelectItem,
  MessageService,
  ConfirmationService
} from 'primeng/primeng';
import { health_passport_storage } from 'src/app/models/patient-profile';
import { PatientService } from 'src/app/services/patient.service';

import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { MedicalReports } from 'src/app/components/shared/patient-view/medical-reports/medical-reports.component';
import { name_input } from 'src/app/constant/constant';
import { SupportService } from 'src/app/services/support.service';
import { ActivatedRoute } from '@angular/router';
export class MedicalTemplate {
  constructor() {
    this.medical_history_count = 0;
    this.docs = 0;
  }
  medical_history_count: number = 0;
  docs: number = 0;

  members = [
    { name: 'Mother', data: [] },
    { name: 'Father', data: [] },
    { name: 'Brother', data: [] },
    { name: 'Sister', data: [] }
  ];

  Document_data = [
    {
      id: 0,
      name: 'Primary Consultation Report',
      data: []
    },
    {
      id: 1,
      name: 'MRI',
      data: []
    },
    {
      id: 2,
      name: 'Blood Report',
      data: []
    },
    {
      id: 3,
      name: 'Ultrasound',
      data: []
    },
    {
      id: 4,
      name: 'X-Ray',
      data: []
    }
  ];
}

class IDForm {
  identification_type: string;
  identification: File;
  show_form = false;
  posting = false;
  has_id = false;
}

interface file_Obj {
  file_id: number;
  document_link: string;
  document_key: string;
  document_name: string;
  document_size: number;
  updated_at?: Date;
  formattedDocumentSize: string;
}
interface DocumentData {
  id: number;
  name: string;
  data: file_Obj[];
}

@Component({
  selector: 'app-upload-documents-main',
  templateUrl: './upload-documents-main.component.html',
  styleUrls: ['./upload-documents-main.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class UploadDocumentsMainComponent implements OnInit {
  readonly name_input: RegExp = name_input;
  displayBasic: boolean;
  readonly acceptedAttachmentTypes = '.jpg,.jpeg,.png,.pdf,.doc,.docx,.dicom';
  id_form: IDForm = new IDForm();
  showTabs: boolean = true;
  confirmDialogVisible = false;
  selectMemeber: SelectItem = null;
  patientGuid: any;
  isSupport: boolean = true;
  consultationId: any;
  health_passport_data: health_passport_storage = new health_passport_storage();
  consultation_id: SelectItem = null;
  new_doc_name;
  MedicalReports: MedicalReports = new MedicalReports();
  Document_data: DocumentData[] = [
    {
      id: 0,
      name: 'PRIMARY CONSULTATION REPORT',
      data: []
    },
    {
      id: 1,
      name: 'MRI',
      data: []
    },
    {
      id: 2,
      name: 'BLOOD REPORT',
      data: []
    },
    {
      id: 3,
      name: 'ULTRASOUND',
      data: []
    },
    {
      id: 4,
      name: 'XRAY',
      data: []
    },
    {
      id: 5,
      name: 'PRESCRIPTION',
      data: []
    }
  ];
  apiResult = new ApiResult(false);
  selectedTab: number = 0;
  constructor(
    private readonly patientservice: PatientService,
    private readonly supportService: SupportService,
    private readonly messageService: MessageService,
    private readonly utilitiesService: UtilitiesService,
    private readonly confirmation: ConfirmationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.consultationId = param.get('consultation_id');
      this.patientGuid = param.get('patient_guid');
      if (param.get('isSupport') == 'true') {
        this.isSupport = true;
      } else {
        this.isSupport = false;
      }
    });
    this.GetDocuments(this.consultationId);
  }

  async uploadFiles(Files: File[], id: number, uploadfileform) {
    for (let file of Files as File[]) {
      const form: FormData = new FormData();
      form.set('patient_guid', this.patientGuid);
      form.set('file', file);
      form.set('folder_name', this.Document_data[id].name);
      form.set('document_name', file.name);
      form.set('document_size', file.size.toString());
      form.set('consultationId', this.consultationId);

      await this.supportService
        .UploadFiles(form)
        .toPromise()
        .then((result) => {
          if (!result.success)
            return this.messageService.add({
              severity: 'error',
              detail: result.error.message
            });
          this.Document_data[id].data.push({
            file_id: result.data.file_id,
            document_link: result.data.document_link,
            document_name: file.name,
            document_size: file.size,
            document_key: result.data.document_key,
            formattedDocumentSize:
              result.data.storageChange.formattedAdditionalSpace
          });
          this.health_passport_data.percentage = Number(
            (
              Number(this.health_passport_data.percentage) +
              Number(result.data.storageChange.percentageIncrease)
            ).toFixed(2)
          );
          this.health_passport_data.formattedStorageSpaceUsed =
            result.data.storageChange.formattedStorageSpaceUsed;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: file.name + ' is uploaded'
          });
        })
        .catch((error: HttpErrorResponse) => {
          return this.messageService.add({
            severity: 'error',
            detail:
              error.status == 500
                ? 'Something went wrong!'
                : error.error.message.toString()
          });
        });
    }
    uploadfileform.clear();
  }

  async DeleteDocument(document_key: string, id: number, file_id: number) {
    const data = {
      patient_guid: this.patientGuid + '',
      document_key: document_key
    };
    await this.supportService
      .DeleteFiles1(data)
      .toPromise()
      .then(async (result) => {
        if (!result.success)
          return this.messageService.add({
            severity: 'error',
            detail: result.error.message
          });
        if (result.success) {
          let temp = [];
          for (let i = 0; i < this.Document_data[id].data.length; i++) {
            if (this.Document_data[id].data[i].file_id != file_id) {
              temp.push(this.Document_data[id].data[i]);
            }
          }
          this.Document_data[id].data = temp;
          this.health_passport_data.percentage = Number(
            (
              Number(this.health_passport_data.percentage) -
              Number(result.data.storageChange.percentageDecrease)
            ).toFixed(2)
          );

          this.health_passport_data.formattedStorageSpaceUsed =
            result.data.storageChange.formattedStorageSpaceUsed;
        }
      })
      .catch((error: HttpErrorResponse) => {
        return this.messageService.add({
          severity: 'error',
          detail:
            error.status == 500
              ? 'Something went wrong!'
              : error.error.message.toString()
        });
      });
  }

  async GetDocuments(consultation_id?: number) {
    let id = this.patientGuid;
    this.MedicalReports.data.api_result.Posting = true;
    await this.supportService
      .GetDocuments(id, { consultation_id })
      .toPromise()
      .then((result) => {
        let a: PromiseResult = result;
        if (result.success) {
          a.data = this.shallow_copy(result.data);
          let fileobj = this.shallow_copy(result.data);
          for (let curr = 0; curr < this.Document_data.length; curr++) {
            this.Document_data[curr].data = [];
            const name = this.Document_data[curr].name
              .replace(/ /g, '_')
              .toLowerCase();
            if (fileobj[name]) {
              this.Document_data[curr].data = fileobj[name];
              fileobj[name] = [];
              this.Document_data[curr].name = this.Document_data[curr].name
                .replace(/_/g, ' ')
                .toUpperCase();
            }
          }
          for (const key of Object.keys(fileobj)) {
            if (fileobj.hasOwnProperty(key)) {
              if (fileobj[key].length > 0) {
                this.Document_data.push({
                  id: this.Document_data.length,
                  name: key.replace(/_/g, ' ').toUpperCase(),
                  data: fileobj[key]
                });
              }
            }
          }
        } else {
          return this.messageService.add({
            severity: 'error',
            detail: result.error.message
          });
          a.data = {};
        }
        this.MedicalReports.data.api_result.PromiseResult = a;
        this.MedicalReports.data.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.MedicalReports.data.api_result.ServerError = error.error;
        this.MedicalReports.data.api_result.Posting = false;
        this.MedicalReports.data.api_result.PromiseResult.success = false;
        return this.messageService.add({
          severity: 'error',
          detail:
            error.status == 500
              ? 'Something went wrong!'
              : error.error.message.toString()
        });
      });
  }

  addDoc() {
    if (this.new_doc_name.length > 0) {
      this.Document_data.push({
        id: this.Document_data.length,
        name: this.new_doc_name,
        data: []
      });
      this.new_doc_name = '';
    }
  }

  showBasicDialog() {
    this.displayBasic = true;
  }

  shallow_copy(a) {
    return this.utilitiesService.shallow_copy(a);
  }

  confirmDocumentDelete(
    event: Event,
    name: string,
    file_id: number,
    id: number,
    document_key: string
  ) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: 'confirm-delete-document',
      message: 'Are you sure to delete the document ' + name + '?',
      accept: () => {
        this.DeleteDocument(document_key, id, file_id);
      }
    });
  }

  async onTabChange(event) {
    let i: number = event.index;
    if (i == 3) {
      await this.GetDocuments(this.consultation_id.value.consultation_id);
    }
  }
}
